import { render } from "./CorsConfiguration.vue?vue&type=template&id=0054212a&scoped=true&lang=pug"
import script from "./CorsConfiguration.vue?vue&type=script&lang=js"
export * from "./CorsConfiguration.vue?vue&type=script&lang=js"

import "./CorsConfiguration.vue?vue&type=style&index=0&id=0054212a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0054212a"]])

export default __exports__